import {
    BudgetOnboardingStep,
    useAreTransactionsSynced,
} from '@common/react/budget';
import { useFinancialEntitiesContext } from '@common/react/financialEntities';
import { useCurrentUser } from '@common/react/user';

export const useNextBudgetOnboardingStep = (): BudgetOnboardingStep => {
    const { fes } = useFinancialEntitiesContext();
    const { userInfo } = useCurrentUser();
    const areTransactionsSynced = useAreTransactionsSynced();

    if (fes.data?.financialEntities.length === 0) {
        return 'link-accounts';
    }

    if (!userInfo.monthlyNetIncome) {
        return 'income';
    }

    if (!areTransactionsSynced) {
        return 'transactions-syncing';
    }

    return 'fixed-expenses';
};
